export const VISUALIZER_FONTS = [
    'Times New Roman',
    'Arial',
    'Open Sans',
    'Verdana',
    'Helvetica',
];

export function quoteFontFamily(fontFamily) {
    if (!fontFamily) {
        return 'Arial';
    }

    const trimmed = String(fontFamily).trim();
    if (trimmed.includes(' ') && !(/['"]/).test(trimmed)) {
        return `"${trimmed}"`;
    }

    return trimmed;
}

export async function loadVisualizerFont(fontFamily, fontSize = 16, fontStyle = 'normal') {
    if (!document.fonts || !fontFamily) {
        return;
    }

    const quoted = quoteFontFamily(fontFamily);
    const size = parseInt(fontSize, 10) || 16;
    const style = fontStyle || 'normal';

    try {
        await document.fonts.load(`${style} ${size}px ${quoted}`);
    } catch (error) {
        console.warn('Nie udało się załadować czcionki:', fontFamily, error);
    }
}

export async function loadVisualizerFonts() {
    if (!document.fonts) {
        return;
    }

    const loads = [];
    VISUALIZER_FONTS.forEach((family) => {
        const quoted = quoteFontFamily(family);
        loads.push(document.fonts.load(`400 16px ${quoted}`));
        loads.push(document.fonts.load(`italic 400 16px ${quoted}`));
        loads.push(document.fonts.load(`700 16px ${quoted}`));
        loads.push(document.fonts.load(`italic 700 16px ${quoted}`));
    });

    await Promise.allSettled(loads);

    try {
        await document.fonts.ready;
    } catch (error) {
        console.warn('Nie udało się doczekać na czcionki wizualizatora:', error);
    }
}
